import { Link, styled, Typography } from '@mui/material';
import { default as MUIBreadcrumbs } from '@mui/material/Breadcrumbs';

export const StyledBreadcrumbs = styled(MUIBreadcrumbs)({
  '& .MuiBreadcrumbs-li': {
    height: '24px',
  },
});

export const StyledLink = styled(Link)(
  ({ $linkDisable }) => `
  max-width: 250px;
  white-space: nowrap;
  overflow: hidden;
  display: flex;
  align-items: center;
  cursor: ${$linkDisable ? '' : 'pointer'};
`,
);

export const StyledText = styled(Typography)(
  ({ $linkDisable }) => `
  margin: 0;
  padding: 0;
  cursor: ${$linkDisable ? '' : 'pointer'};
`,
);
